export const resetStore = ({ store }) => {
    const initialState = structuredClone(store.$state);
    // eslint-disable-next-line no-param-reassign
    store.$reset = () => store.$patch(structuredClone(initialState));
};
